export const staffUserSeed = [
  {
    staffId: 'STF-001',
    fullName: 'Priya Sharma',
    email: 'priya.sharma@utkarsh.com',
    mobile: '9876500001',
    roleIds: ['ROLE-SUPER'],
    scopeType: 'all',
    buId: '',
    siteId: '',
    active: true,
    lastLoginAt: '2026-08-12T09:15:00',
  },
  {
    staffId: 'STF-002',
    fullName: 'Rahul Mehta',
    email: 'rahul.mehta@utkarsh.com',
    mobile: '9876500002',
    roleIds: ['ROLE-KYC'],
    scopeType: 'all',
    buId: '',
    siteId: '',
    active: true,
    lastLoginAt: '2026-08-11T16:40:00',
  },
  {
    staffId: 'STF-003',
    fullName: 'Kavita Jadeja',
    email: 'kavita.jadeja@utkarsh.com',
    mobile: '9876500003',
    roleIds: ['ROLE-BU-MGR'],
    scopeType: 'bu',
    buId: 'BU-APMUL',
    siteId: '',
    active: true,
    lastLoginAt: '2026-08-10T11:20:00',
  },
  {
    staffId: 'STF-004',
    fullName: 'Vikram Patel',
    email: 'vikram.patel@utkarsh.com',
    mobile: '9876500004',
    roleIds: ['ROLE-INDENT'],
    scopeType: 'bu_site',
    buId: 'BU-APMUL',
    siteId: 'ST-MSPVL',
    active: true,
    lastLoginAt: '2026-08-12T08:05:00',
  },
  {
    staffId: 'STF-005',
    fullName: 'Anita Desai',
    email: 'anita.desai@utkarsh.com',
    mobile: '9876500005',
    roleIds: ['ROLE-MASTER'],
    scopeType: 'all',
    buId: '',
    siteId: '',
    active: true,
    lastLoginAt: '2026-08-09T14:00:00',
  },
  {
    staffId: 'STF-006',
    fullName: 'Inactive Demo User',
    email: 'inactive@utkarsh.com',
    mobile: '9876500006',
    roleIds: ['ROLE-INDENT'],
    scopeType: 'bu',
    buId: 'BU-MSTPL',
    siteId: '',
    active: false,
    lastLoginAt: null,
  },
];
